import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { GetSingleSurvey, reset } from "../../../features/SurveySlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Table,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";

const FormSurveyPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    deskripsi: "",
    active: true,
    detail: [],
  });

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.survey);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(GetSingleSurvey({ id, token }));
  }

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      deskripsi: data?.data?.deskripsi,
      detail: data?.data?.detail,
      active: data?.data?.active,
    });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/survey/${id}`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/survey`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/master/survey/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/survey/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/survey/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/survey/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          setNewData={setNewData}
          isLoading={isLoading}
          isLocked={param.pathname.split("/")[3] === "view" || isLoading}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  isLoading = false,
  handleSubmit,
}) => {
  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="Nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={isLocked}
                  value={newData.nama || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, nama: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="Deskripsi">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Deskripsi"
                  name="deskripsi"
                  disabled={isLocked}
                  value={newData.deskripsi || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, deskripsi: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <hr data-content="Detail" className="hr-text" />
            <Col md={12} className="mb-3">
              <Table
                responsive
                striped
                className="table-centered table-nowrap rounded mb-0"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>
                    <th className="border-0">Deskripsi</th>
                    <th className="border-0">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(newData.detail || []).length > 0 ? (
                    <>
                      {newData.detail?.map((item, i) => (
                        <tr key={i}>
                          <th>{i + 1}</th>
                          <th>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Deskripsi"
                              name="deskripsi_detail"
                              disabled={isLocked}
                              value={id ? item.deskripsi || "" : item || ""}
                              onChange={(e) => {
                                if (id) {
                                  // update the detail list
                                  const copyDetail = [...newData.detail];
                                  copyDetail[i] = Object.assign(
                                    { ...copyDetail[i] },
                                    {
                                      deskripsi: e.target.value,
                                    }
                                  );
                                  const updatedDetail = copyDetail;

                                  // edited
                                  if (
                                    newData?.editedDetail?.some(
                                      (obj) => obj.id === item.id
                                    )
                                  ) {
                                    // update existing data instead of creating new one
                                    const theIdx =
                                      newData?.editedDetail?.findIndex(
                                        (obj) => obj.id === item.id
                                      );
                                    const copyEditedDetail = [
                                      ...newData.editedDetail,
                                    ];
                                    copyEditedDetail[theIdx] = Object.assign(
                                      { ...copyEditedDetail[theIdx] },
                                      {
                                        deskripsi: updatedDetail[i].deskripsi,
                                      }
                                    );
                                    const updatedEditDetail = copyEditedDetail;
                                    setNewData({
                                      ...newData,
                                      detail: [...updatedDetail],
                                      editedDetail: [...updatedEditDetail],
                                    });
                                  } else {
                                    const updatedEditDetail = [
                                      ...(newData?.editedDetail || []),
                                      {
                                        id: updatedDetail[i].id,
                                        deskripsi: updatedDetail[i].deskripsi,
                                      },
                                    ];
                                    setNewData({
                                      ...newData,
                                      detail: [...updatedDetail],
                                      editedDetail: [...updatedEditDetail],
                                    });
                                  }
                                } else {
                                  const copy = [...newData.detail];
                                  copy[i] = e.target.value;
                                  const updatedDetail = copy;
                                  setNewData({
                                    ...newData,
                                    detail: [...updatedDetail],
                                  });
                                }
                              }}
                            />
                          </th>
                          <th style={{ textAlign: "center" }}>
                            <ButtonGroup size="sm">
                              <Button
                                variant="danger"
                                disabled={isLocked}
                                onClick={() => {
                                  if (id) {
                                    // add into to deleted list to process in BE
                                    const updatedRemoveDetail = [
                                      ...(newData?.removeDetail || []),
                                      newData.detail[i].id,
                                    ];
                                    // delete actual detail
                                    const copyDetail = [...newData.detail];
                                    copyDetail.splice(i, 1);
                                    const updatedDetail = copyDetail;
                                    setNewData({
                                      ...newData,
                                      detail: [...updatedDetail],
                                      removeDetail: [...updatedRemoveDetail],
                                    });
                                  } else {
                                    const copyDetail = [...newData.detail];
                                    copyDetail.splice(i, 1);
                                    const updatedDetail = copyDetail;
                                    setNewData({
                                      ...newData,
                                      detail: [...updatedDetail],
                                    });
                                  }
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </ButtonGroup>
                          </th>
                        </tr>
                      ))}
                      {/* UNTUK DATA BARU */}
                      {newData.addDetail?.map((item, i) => (
                        <tr key={i}>
                          <th>{newData.detail.length + (i + 1)}</th>
                          <th>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Deskripsi"
                              name="deskripsi_addDetail"
                              disabled={isLocked}
                              value={item || ""}
                              onChange={(e) => {
                                const copy = [...newData.addDetail];
                                copy[i] = e.target.value;
                                const updatedDetail = copy;
                                setNewData({
                                  ...newData,
                                  addDetail: [...updatedDetail],
                                });
                              }}
                            />
                          </th>
                          <th style={{ textAlign: "center" }}>
                            <ButtonGroup size="sm">
                              <Button
                                variant="danger"
                                disabled={isLocked}
                                onClick={() => {
                                  const copyDetail = [...newData.addDetail];
                                  copyDetail.splice(i, 1);
                                  const updatedDetail = copyDetail;
                                  setNewData({
                                    ...newData,
                                    addDetail: [...updatedDetail],
                                  });
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </ButtonGroup>
                          </th>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <th colSpan="3" style={{ textAlign: "center" }}>
                        Tidak ada data!
                      </th>
                    </tr>
                  )}
                </tbody>
              </Table>
              {!isLocked ? (
                <div className="d-grid">
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => {
                      if (id) {
                        // edited
                        const updatedAddDetail = [
                          ...(newData?.addDetail || []),
                          "",
                        ];
                        setNewData({
                          ...newData,
                          addDetail: [...updatedAddDetail],
                        });
                      } else {
                        const updatedDetail = [...(newData?.detail || []), ""];
                        setNewData({
                          ...newData,
                          detail: [...updatedDetail],
                        });
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Tambah
                  </Button>
                </div>
              ) : null}
            </Col>
          </Row>
          <div>
            {!isLocked ? (
              <Button type="submit">{id ? "Update" : "Simpan"}</Button>
            ) : null}
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormSurveyPage;
